var cloudflareTurnstile = function () {

    var publicMethods = {};

    var checkIntervalInMilliseconds = 1000;
    var checkLimitBeforeShowingError = 5;

    var turnstileDataAttribute = 'data-turnstile';
    var elements;

    var turnstileWarningDataAttribute = 'data-turnstile-warning';
    var warnings;

    var turnstileButtonDataAttribute = 'data-turnstile-button';

    var turnstileInstructionDataAttribute = 'data-turnstile-instruction';

    var apiKey = window.serverData.recaptchaApiKey || '';

    publicMethods.init = function () {

        if (apiKey === '') {

            console.warn('No API key found for Turnstile, all submit buttons enabled.');
            enableAllButtons();
            return;

        }

        elements = document.querySelectorAll('[' + turnstileDataAttribute + ']');
        if (!elements.length) return;

        injectScript();

        warnings = document.querySelectorAll('[' + turnstileWarningDataAttribute + ']');
        if (!warnings.length) return;

        if (turnstileDefined()) return;

        check();

    };

    function injectScript() {

        if (document.querySelector('script[src*="turnstile/v0"]')) return;

        var script = document.createElement('script');
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
        script.async = true;
        script.onload = function () { setup(); };

        document.head.appendChild(script);

    }

    function setup() {

        for (var i = 0; i < elements.length; i++) {

            (function (i) {

                var element = elements[i];
                var widgetId;
                var form = element.closest('form');
                var button = form ? form.querySelector('[' + turnstileButtonDataAttribute + ']') : null;
                var instruction = form ? form.querySelector('[' + turnstileInstructionDataAttribute + ']') : null;

                var checkingText = (instruction && instruction.getAttribute(turnstileInstructionDataAttribute + '-checking-text')) || 'We are verifying that you are human. The submit button will be enabled once the check is complete.';
                var errorText = (instruction && instruction.getAttribute(turnstileInstructionDataAttribute + '-error-text')) || 'Verification could not be completed automatically. Please interact with the checkbox above.';
                var successText = (instruction && instruction.getAttribute(turnstileInstructionDataAttribute + '-success-text')) || 'Verification successful. You can now submit the form.';

                var turnstileCheckComplete = false;

                if (form) {

                    form.addEventListener('submit', function (event) {

                        if (!turnstileCheckComplete) {

                            event.preventDefault();
                            return false;

                        }

                    });

                }

                widgetId = turnstile.render(element, {
                    sitekey: apiKey,
                    callback: function (token) {

                        if (instruction) instruction.textContent = successText;
                        turnstileCheckComplete = true;
                        if (button) button.disabled = false;

                    },
                    expired_callback: function () {

                        if (instruction) instruction.textContent = checkingText;
                        turnstileCheckComplete = false;
                        if (button) button.disabled = true;
                        turnstile.reset(widgetId);

                    },
                    error_callback: function () {

                        if (instruction) instruction.textContent = errorText;
                        turnstileCheckComplete = false;
                        if (button) button.disabled = true;
                        showWarnings();

                    }
                });

            })(i);

        }

    }

    function check() {

        var numberOfChecks = 0;

        var checkInterval = setInterval(function () {

            if (numberOfChecks >= checkLimitBeforeShowingError) showWarnings();

            if (turnstileDefined()) {

                hideWarnings();
                clearInterval(checkInterval);

            }

            numberOfChecks++;

        }, checkIntervalInMilliseconds); 

    };

    function turnstileDefined() {

        return typeof window.turnstile !== "undefined" && typeof window.turnstile.render === "function";

    };

    function showWarnings() {

        for (var i = 0; i < warnings.length; i++) {

            (function (i) {

                warnings[i].style.display = 'block';

            })(i);

        }

    };

    function hideWarnings() {

        for (var i = 0; i < warnings.length; i++) {

            (function (i) {

                warnings[i].style.display = null;

            })(i);

        }

    };

    function enableAllButtons() {

        var turnstileButtons = document.querySelectorAll('[' + turnstileButtonDataAttribute + ']');
        if (!turnstileButtons.length) return;

        for (var i = 0; i < turnstileButtons.length; i++) {

            (function (i) {

                turnstileButtons[i].disabled = false;

            })(i);

        }

    }

    return publicMethods;

}();

cloudflareTurnstile.init();
